
import Vue from 'vue'
import { IdName } from '@ViewModels/IdName'

export default Vue.extend({
   name: 'Roles',
   props: {
      value: Array as () => string[],
   },
   computed: {
      roleOptions(): IdName[] {
         return this.$store.getters.roleOptions
      },
      rolenames(): string {
         return this.value
            .map(roleId => {
               const match = this.roleOptions.find(
                  opt => opt.Id.toLowerCase() === roleId.toLowerCase()
               )
               return match ? match.Name : ''
            })
            .filter(name => (name === 'SchoolAdmin' ? '' : name))
            .filter(name => name.length > 0)
            .join(', ')
      },
   },
})
